import React, { useEffect, useState } from "react";
import { Link } from "react-router";

import {
  ChevronLeftIcon,
  ChevronRightIcon
} from "../../icons";
import { co } from "@fullcalendar/core/internal-common";

interface PaginationProps {
  totalRecords: number;
  perPage: number;
  currentPage: number; // Additional custom classes for styling
  handlePgNav: any;
  handleChangePg: any;
}

const Pagination: React.FC<PaginationProps> = ({
  totalRecords,
  perPage = 10,
  currentPage = 1,
  handlePgNav,
  handleChangePg
}) => {

  const [startFrom, setStartFrom] = useState(1);
  const [endTo, setEndTo] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [pageNumbers, setPageNumbers] = useState<any[]>([]);

  //const [page, setPage] = useState(currentPage);
  //const [recordsPerPage, setRecordsPerPage] = useState(perPage);
  //const [totalRecords, setTotalRecords] = useState(totalRecord);

  //const [filterSection, setFilterSection] = useState(false);
  useEffect(() => {
    let start = (currentPage - 1) * perPage + 1;
    let end = currentPage * perPage;
    if (end > totalRecords) {
      end = totalRecords;
    }

    setStartFrom(start);
    setEndTo(end);
    
    let totalPages = Math.ceil(totalRecords / perPage);
    
    setTotalPages(totalPages);

  }, [totalRecords, perPage, currentPage]);

  useEffect(() => {
    
    let pages: any[] = [];

    if(totalPages > 7){
      pages = [1,2,3,4,5, "...", totalPages];
    }
    else if(totalPages > 0){
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    }

    setPageNumbers(pages);
  }, [totalPages]);

  return (
    <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-gray-500">
            Showing <span className="font-medium">{startFrom}</span> to <span className="font-medium">{endTo}</span> of{' '}
            <span className="font-medium">{totalRecords}</span> results
          </p>
        </div>
        <div>
          <nav aria-label="Pagination" className="isolate inline-flex -space-x-px rounded-md shadow-sm">
            {
              perPage > 0 && pageNumbers.length > 1
              ?
                <>
                  <a
                    href="javascript:void(0);"
                    onClick={() => handlePgNav("prev")}
                    className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                  >
                    <span className="sr-only">Previous</span>
                    <ChevronLeftIcon aria-hidden="true" className="size-5" />
                  </a>
                  {pageNumbers.map((pgNum, index) => (

                    
                    pgNum === "..." ?
                      <span
                        key={index}
                        className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300 focus:outline-offset-0"
                      >
                        ...
                      </span>
                    :
                      
                      <a
                        key={index}
                        onClick={() => handleChangePg(pgNum)}
                        href="javascript:void(0);"
                        aria-current={pgNum === currentPage ? "page" : undefined}
                        className={
                          (pgNum === currentPage
                            ? "relative z-10 inline-flex items-center bg-indigo-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            : "relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0")
                        }
                      >
                        {pgNum}
                      </a>
                      
                  ))}
                  
                  <a
                    href="javascript:void(0);"
                    onClick={() => handlePgNav("next")}
                    className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                  >
                    <span className="sr-only">Next</span>
                    <ChevronRightIcon aria-hidden="true" className="size-5" />
                  </a>
                </>
              :
              null
            }
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Pagination;